import {h, Fragment, Component} from "preact";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {route} from "preact-router";

import Config from "../config";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../mobile-templates/event.jsx";
import * as D from "../desktop-templates/prematch-single-event.jsx";
import * as I from "../utils/icons";
import {groupMarketsByName} from "../mobile-pages/prematch-event.jsx";

import {CollapsibleMarket as MobileCollapsibleMarket, TabBasedContent} from "../mobile-pages/live-event.jsx";
import {ColumnsMarketDivision} from "./prematch-event.jsx";

import EmbeddedTracker from "../../tracker/widget";
import Observer from "../utils/observer";
import AwrabetLiveEvent, {
	CollapsibleMarket as AwrabetCollapsibleMarket,
	GenericEventPanel as AwrabetGenericEventPanel,
	LiveTrackerByEventPanel as AwrabetLiveTrackerByEventPanel,
	LiveEventDetailsPanel as AwrabetLiveEventDetailsPanel,
	LiveEventContent as AwrabetLiveEventContent,
	LiveTrackerHugePanel as AwrabetLiveTrackerHugePanel
} from '../../awrabet/desktop-components/live-event.jsx';

export default class LiveEvent extends AwrabetLiveEvent {
	render({eventId}) {
		if (LFeed.menu == null)
			return null;
		const event = LFeed.getEvent('/event/'+eventId);
		if (event == null)
			return null; // Torna al menu
		const tournament = LFeed.getTournament(event.parent);
		const sport = LFeed.menu[tournament.parent];
		return <LiveEventContent key={event.id} eventId={event.id} tournament={tournament} sport={sport}  />
	}
}


export class LiveEventContent extends AwrabetLiveEventContent {
	render({eventId, tournament, sport}) {
		const event = LFeed.getEvent(eventId);
		const currentTab = this.getCurrentTab(event);
		const markets = this.getMarketsToDisplay(event);
		const odds = groupMarketsByName(markets);

		return <Fragment>
			{/*<P.EventName>{sport.name} / {tournament.name}</P.EventName>
			<P.LiveEventNameLarge event={event} />
			<P.EventInfoRow>
				<P.EventInfoCell>{event.status.phase}</P.EventInfoCell>
				<P.EventInfoCell>{event.status.timer ? event.status.timer+"'" : 'LIVE'}</P.EventInfoCell>
			</P.EventInfoRow>*/}
			<LiveEventDetailsPanel event={event} />

			<D.ScrollableTabsRail>
				<D.ScrollableTabsContent>
					{this.extractTabs(event).map(tab =>
						<D.TabButton active={currentTab.id == tab.id} onClick={() => this.setState({currentTab: tab.id})}>
							{tab.name}
						</D.TabButton>
					)}
				</D.ScrollableTabsContent>
			</D.ScrollableTabsRail>

			<ColumnsMarketDivision key={currentTab && currentTab.id} columns={2} odds={Object.values(odds)} rowComponent={CollapsibleMarket} />
		</Fragment>
	}
}

export class CollapsibleMarket extends AwrabetCollapsibleMarket {
	render({open, marketGroup}) {
		return <D.MarketsContainer>
			<D.MarketHeadRow active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				<D.MarketCollapseButton active={this.state.open}>
					<I.UpArrowIcon class={"h-4 transition-transform "+(this.state.open ? '' : 'rotate-180')} />
				</D.MarketCollapseButton>
				<D.MarketName>{marketGroup.name}</D.MarketName>
			</D.MarketHeadRow>

			{this.state.wasOpen && <D.OutcomesContainer open={this.state.open}>
				{marketGroup.sub.map(market => <D.OutcomesContainerRow cols={Object.keys(market.sub).length}>
					{Object.values(market.sub).map(outcome => (
						<D.OutcomeButton
							selected={Ticket.hasLiveOdds(outcome.id)}
							onClick={() => Ticket.toggleLiveOdds(outcome.id)}>
							<D.OutcomeName>{outcome.name}</D.OutcomeName>
							<D.OutcomeValue selected={Ticket.hasLiveOdds(outcome.id)} value={outcome.value} />
						</D.OutcomeButton>
					))}
				</D.OutcomesContainerRow>)}
			</D.OutcomesContainer>}
		</D.MarketsContainer>;
	}
}


export class GenericEventPanel extends AwrabetGenericEventPanel {

	render({event}) {
		const config = this.fetchGenericSportConfig(event);
		const phaseArray = new Array(config.phasecount).fill(1);

		return <div class="m-auto w-120 h-32 rounded relative">
			<div class="w-full h-full bg-black opacity-70 absolute top-0 left-0 z-10 rounded" />
			<div class="absolute top-0 left-0 z-20 w-full h-full main-text-color text-center">
				<div class="text-xs flex px-2 py-1 border-b border-(--body-text-color)">
                    <span class="w-full text-left">
                        <i class="fa fa-stopwatch mr-2" />
						{!!event.status.timer && <span>{event.status.timer.length > 8? event.status.timer.substring(0,8) : event.status.timer}'</span>}
                    </span>
					<span class="w-full text-center">{window.Translation(event.status.phase)}</span>
				</div>

				<table class="w-full text-center">
					<thead>
					<tr>
						<th class="py-1" />
						{phaseArray.map((p, idx) => <th class="py-1">{idx + 1}</th>)}
						<th class="py-1">{config.phasename}</th>
						{!!config.ballpossess && <th class="py-1" />}
					</tr>
					</thead>
					<tbody>
					{['home','away'].map((team,index) => <tr>
						<td class="py-1"><span>{event.teams[team].name}</span></td>
						{phaseArray.map((p,i) => <td class="py-1">{!!event.result[i]? event.result[i].result.split('-')[index] : '0'}</td>)}
						<td class="py-1">{event.current.result[index]}</td>
						{!!config.ballpossess && <td class="py-1"><i class={"sporticon livesport-"+ event.sport.split('/').slice(2,3).join() +" main-text-color w-4 inline-block"} /></td>}
					</tr>)}
					</tbody>
				</table>
			</div>
		</div>;
	}
}

export function TeamIcon({team}) {
	const homeTeamId = parseInt(team.id.split('/').slice(3,4).join());
	const teamIconUrl = 'https://api.sportstats.eu/scudetti/hi-res/'//+ Math.floor(homeTeamId / 2000) +'/'+ homeTeamId +'.png';
	return <img class="h-10" src={teamIconUrl} alt={team.name} />;
}

export function SoccerMatchInfo({event}) {
	return <div class="m-auto w-120 h-40 rounded relative">
		<div class="w-full h-full bg-black opacity-70 absolute top-0 left-0 z-10 rounded" />
		<div class="absolute top-0 left-0 z-20 w-full h-full main-text-color text-center">
			<div class="text-xs flex px-2 py-1 border-b border-(--body-text-color)">
				<span class="w-full text-left">
					<i class="fa fa-stopwatch mr-2" />
					{!!event.status.timer && <span>{event.status.timer.length > 8? event.status.timer.substring(0,8) : event.status.timer}'</span>}
				</span>
				<span class="w-full text-right">{window.Translation(event.status.phase)}</span>
			</div>
			<div class="flex flex-row items-center justify-center font-bold px-3 py-4 border-b  border-(--body-text-color)">
				<span class="shrink-0">
					<TeamIcon team={event.teams.home} />
				</span>
				<div class="w-full text-xs">
					<span>{event.teams.home.name}</span>
				</div>
				<div class="shrink-0 w-32 text-2xl tracking-wider section-highlight-color">
					{event.current.result.join(' - ')}
				</div>
				<div class="w-full text-xs">
					<span>{event.teams.away.name}</span>
				</div>
				<span class="shrink-0">
					<TeamIcon team={event.teams.away} />
				</span>
			</div>
		</div>
	</div>;
}

export function SoccerRealTimeTracker({event}) {
	return <div class="eventinfo-tracker-combo">
		<div class="flex flex-row items-center justify-center font-bold px-3 py-4 bg-slate-100 text-slate-950">
			<div class="w-1/2 flex items-center justify-end gap-2">
				<span class="shrink-0">
					<TeamIcon team={event.teams.home} />
				</span>
				<div class="text-base">
					<span>{event.teams.home.name}</span>
				</div>
			</div>
			<div class="shrink-0 w-32 text-2xl tracking-wider section-highlight-color text-center">
				{event.current.result.join(' - ')}
			</div>
			<div class="w-1/2 flex items-center justify-start gap-2">
				<div class="text-base">
					<span>{event.teams.away.name}</span>
				</div>
				<span class="shrink-0">
					<TeamIcon team={event.teams.away} />
				</span>
			</div>
		</div>
		<EmbeddedTracker eventId={event.id} isHorizontal={true} info={true} chart={true} stats={false} />
	</div>
}

export class LiveTrackerByEventPanel extends AwrabetLiveTrackerByEventPanel {

	render({event}) {
		if (!event || !event.brId || !this.state.livestream) {
			return null;
		}

		return (
			<div class="panel relative">
				<iframe
					scrolling="no"
					style="width:100%;height:100%;aspect-ratio:8.3/9;"
					allowFullScreen={true}
					src={this.state.livestream}
				/>
			</div>
		);
	}
}

export class LiveEventDetailsPanel extends AwrabetLiveEventDetailsPanel {
	render({event}) {
		if (!event) return null;

		const isSoccer = event.sport === '/sport/1'; // Assuming '/sport/1' represents soccer
		const partialResults = !isSoccer ? event.result : null;

		// Determine the label for partial results based on the sport
		let partialLabel = '';
		if (event.sport === '/sport/14') partialLabel = 'SET'; // Tennis
		else if (event.sport === '/sport/2') partialLabel = 'Q'; // Basketball
		else partialLabel = 'T'; // Default label

		return (
			<div class="bg-t">
				{/* Display the current result at the top */}
				<div class="flex flex-row items-center justify-center font-bold px-3 py-4 bg-harif-800 text-white">
					<div class="w-1/2 flex items-center justify-end gap-2">
						<span class="shrink-0">
							<TeamIcon team={event.teams.home} />
						</span>
						<div class="text-base">
							<span>{event.teams.home.name}</span>
						</div>
					</div>
					<div class="shrink-0 w-32 text-2xl tracking-wider section-highlight-color text-center">
						{event.current.result.join(' - ')}
					</div>
					<div class="w-1/2 flex items-center justify-start gap-2">
						<div class="text-base">
							<span>{event.teams.away.name}</span>
						</div>
						<span class="shrink-0">
							<TeamIcon team={event.teams.away} />
						</span>
					</div>
				</div>

				{/* Display partial results for non-soccer sports */}
				{partialResults && (
					<div class="px-3 py-2 bg-slate-200 text-slate-900">
						<table class="w-full text-center">
							<thead>
							<tr>
								<th></th>
								{partialResults.map((_, index) => (
									<th key={index}>{partialLabel} {index + 1}</th>
								))}
							</tr>
							</thead>
							<tbody>
							{['home', 'away'].map((team, teamIndex) => (
								<tr key={team}>
									<td>{event.teams[team].name}</td>
									{partialResults.map((result, index) => (
										<td key={index}>
											{result.result.split('-')[teamIndex]}
										</td>
									))}
								</tr>
							))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		);
	}
}


/**
 * Ora non uasto, prima aveva il campetto e una serie di info della partita a centro schermo
 */
export class LiveTrackerHugePanel extends AwrabetLiveTrackerHugePanel {

	render({event, toggleTrackerType}) {
		toggleTrackerType = null;
		if (!event || !event.brId) {
			return null;
		}

		return <div class="panel relative">
			{!!toggleTrackerType && <a href="javascript:void(0);" onClick={e => toggleTrackerType()} class="z-50 bg-gray-600 text-white opacity-60 hover:bg-gray-400 rounded text-xl text-center py-2 px-4 absolute right-3 top-3">
				<i class="fa fa-compress" />
			</a>}
			{!!this.state.livestream && <div class="flex gap-0.5 items-center justify-center text-center text-xs leading-6 main-text-color">
				<a class={"w-full"+ (this.state.tracker? ' main-color' : '')} href="javascript:void(0);" onClick={e => this.setState({tracker:true})}>Tracker</a>
				<a class={"w-full"+ (!this.state.tracker? ' main-color' : '')} href="javascript:void(0);" onClick={e => this.setState({tracker:false})}>LiveStream</a>
			</div>}
			{this.state.tracker
				? this.largeTracker(event)
				: <iframe scrolling="no" style="width:100%;aspect-ratio:16/9;" allowFullScreen={true} src={this.state.livestream} />}
		</div>;
	}
}
